import { KpiSettingsView } from './KpiSettingsView'
import { LinearCustomersView } from './LinearCustomersView'
import { LinkMismatchWarning } from './LinkMismatchWarning'
import { RemovedMeetingsView } from './RemovedMeetingsView'

export function ClientDashboardsSettings() {
  return (
    <section aria-labelledby="client-dashboards-settings">
      <div className="container mx-auto max-w-4xl px-6 pb-3 pt-2">
        <h2 id="client-dashboards-settings" className="text-base font-semibold text-etn-text">
          Client dashboards
        </h2>
      </div>
      <LinearCustomersView />
      <LinkMismatchWarning />
      <RemovedMeetingsView />
      <KpiSettingsView />
    </section>
  )
}
